// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu-module--menu--1MdG-","open":"Menu-module--open--1dSmu"};